import React, { useState } from 'react';
import { Semver } from '../Components/Semver';
import SideBar from '../Components/home/SideBar';
import WelcomeBannerHome from '../Components/home/WelcomeBannerHome';
import ReleasePackages from '../Components/home/ReleasePackages';
import DeploymentPackages from '../Components/home/DeploymentPackages';
import { ArtifactTable } from '../Components/home/ArtifactTable';
import StableVersion from '../Components/home/StableVersion';
import { DeviceTypeName } from './types';

export const Home = () => {
  const [reRender, setReRender] = useState<boolean>(false);

  const deviceList = [DeviceTypeName.TRUCK, DeviceTypeName.VAN];
  const triggerRefresh = () => {
    setReRender(true);
  };

  return (
    <div>
      <WelcomeBannerHome subtitle="Have fun doing Condor stuff" />
      <div style={{ display: 'flex' }}>
        <div style={{ flexBasis: '20%' }}>
          <SideBar />
        </div>
        <div style={{ flexBasis: '80%' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ flexBasis: '25%' }}></div>
            <div style={{ flexBasis: '50%' }}>
              <StableVersion reRender={reRender} />
            </div>
            <div style={{ flexBasis: '25%' }}></div>
          </div>
          <ReleasePackages triggerRefresh={triggerRefresh} />
          <DeploymentPackages status="active" key="active" />
          <DeploymentPackages status="inactive" key="inactive" />
          <ArtifactTable deviceList={deviceList} />
          <Semver />
        </div>
      </div>
    </div>
  );
};
